module.exports = __webpack_public_path__ + "static/media/Bluelab-Replacement-Large-Pump-Cassette-1200ml-suitable_PUMPCONT-L_1.6371e4af.webp";